import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['variant', 'selection', 'option', 'variantTab', 'variantEnabledState']

  connect() {
    this.showVariant()
  }

  showVariant() {
    this.variantTargets.forEach((variant, index) => {
      if (this.variantTabTargets[index].checked) {
        variant.classList.remove('hidden')
      }
      else {
        variant.classList.add('hidden')
      }
    })
  }

  toggleVariant(e) {
    const element = e.target
    const variantName = element.dataset.variantName
    const enable = element.checked
    element.value = enable

    if (this.optionTargets.includes(element)) return

    this.optionTargets.forEach((option) => {
      if (option.dataset.variantName === variantName) {
        option.checked = enable
        option.value = enable
      }
    })

    this.variantEnabledStateTargets.forEach((option) => {
      if (option.dataset.variantName === variantName) {
        option.innerText = enable ? 'ON' : 'OFF'
      }
    })
  }
}
